"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const withStyles_1 = require("@material-ui/core/styles/withStyles");
const withTheme_1 = require("@material-ui/core/styles/withTheme");
const config_1 = require("@pbl/pbl-react-core/lib/config/config");
const DateTimeFormatter_1 = require("@pbl/pbl-react-core/lib/utils/DateTimeFormatter");
const mediaUtil_1 = require("@pbl/pbl-react-core/lib/utils/mediaUtil");
const TimeUtil_1 = require("@pbl/pbl-react-core/lib/utils/TimeUtil");
const classnames_1 = require("classnames");
const moment = require("moment-timezone");
const numeral = require("numeral");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const assets_1 = require("../config/assets");
const config_2 = require("../config/config");
const Details_1 = require("../detail-page/Details");
const PrizesDialog_1 = require("../dialog/PrizesDialog");
const WinnersDialog_1 = require("../dialog/WinnersDialog");
const VideoModal_1 = require("../earn/VideoModal");
const Icon_1 = require("../icon/Icon");
const ReadMore_1 = require("../read-more/ReadMore");
const ChipTabs_1 = require("../tabs/ChipTabs");
const EntriesBox_1 = require("./EntriesBox");
const DrawDetailStyle_1 = require("./jss/DrawDetailStyle");
const drawDateFormatter = (dateString, dateFormatterKey, dateFormatter) => !!dateFormatter
    ? DateTimeFormatter_1.default.getFormattedDateFromDateString(dateFormatterKey, dateString)
    : moment(dateString).tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format('MMMM DD, YYYY hh:mm A');
const getDrawDates = (draw) => {
    var _a, _b, _c;
    let drawStartDate = '';
    if (draw && draw.start) {
        drawStartDate = drawDateFormatter(draw.start, 'drawStartEndDateFormat', (_a = config_1.react_core_config.internalConfig.dateFormatter) === null || _a === void 0 ? void 0 : _a.drawStartEndDateFormat);
    }
    let drawEndDate = '';
    if (draw && draw.end) {
        drawEndDate = drawDateFormatter(draw.end, 'drawStartEndDateFormat', (_b = config_1.react_core_config.internalConfig.dateFormatter) === null || _b === void 0 ? void 0 : _b.drawStartEndDateFormat);
    }
    let drawDate = '';
    if (draw && draw.draw) {
        drawDate = drawDateFormatter(draw.draw, 'drawDrawDateFormat', (_c = config_1.react_core_config.internalConfig.dateFormatter) === null || _c === void 0 ? void 0 : _c.drawDrawDateFormat);
    }
    return {
        drawStartDate,
        drawEndDate,
        drawDate
    };
};
class PastDrawDetail extends React.Component {
    constructor(props) {
        super(props);
        this.getTotalEntries = () => {
            if (!this.props.isLoggedIn) {
                return null;
            }
            return ((0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(EntriesBox_1.default, { entries: this.props.entries }) })));
        };
        this.startVideo = () => {
            const { selectedReward } = this.props;
            if (!!selectedReward && !!selectedReward.extra_data && !!selectedReward.extra_data.preview_url) {
                this.setState({ launchVideo: true });
            }
        };
        this.closeVideo = () => {
            this.setState({ launchVideo: false });
        };
        this.renderImage = (title, image) => {
            const { classes, selectedReward, t } = this.props;
            const isPreviewUrlAvailable = !!selectedReward && !!selectedReward.extra_data && !!selectedReward.extra_data.preview_url;
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ container: true, item: true, xs: 12, md: 5 }, { children: (0, jsx_runtime_1.jsxs)(core_1.Card, Object.assign({ className: classes.imageCard }, { children: [(0, jsx_runtime_1.jsx)("img", { alt: `Image of draw ${title}`, title: `Image of reward Image of draw ${title}`, src: image, className: (0, classnames_1.default)({
                                    [classes.imageStyle]: true,
                                    [classes.overlay40]: isPreviewUrlAvailable
                                }) }), isPreviewUrlAvailable && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: assets_1.assets.internalAssets.playLogo, color: config_2.config.internalConfig.BUTTON_BACKGROUND, onClick: this.startVideo, className: classes.playIcon }), (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "h6", className: classes.previewText }, { children: t('reward.watchVideo', 'Watch Video') }))] })), (0, jsx_runtime_1.jsx)(VideoModal_1.default, { videoUrl: isPreviewUrlAvailable && !!selectedReward ? selectedReward.extra_data.preview_url : '', launchVideo: this.state.launchVideo, onClose: this.closeVideo })] })) })) }));
        };
        this.renderStats = (drawStartDate, drawEndDate, drawDate, pointsBalance, isLoggedIn) => {
            const data = [
                {
                    title: this.props.t('reward.pastReward.startDate'),
                    text: drawStartDate
                },
                {
                    title: this.props.t('reward.pastReward.drawDate'),
                    text: drawDate
                },
                {
                    title: this.props.t('reward.pastReward.endDate'),
                    text: drawEndDate
                },
                {
                    title: isLoggedIn && config_2.config.internalConfig.SHOW_USER_POINTS ? this.props.t('reward.pastReward.pointsBalance') : '',
                    text: isLoggedIn && config_2.config.internalConfig.SHOW_USER_POINTS ? pointsBalance : ''
                }
            ];
            return (0, jsx_runtime_1.jsx)(Details_1.default, { data: data });
        };
        this.renderButtons = (hasWinners, winnersButtonLabel, drawEnded, rewardCost) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(core_1.Grid, Object.assign({ item: true, xs: 12, sm: 6, lg: 7 }, { children: [drawEnded ? ((0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ size: "large", variant: "contained", color: config_2.config.internalConfig.BUTTON_BACKGROUND, fullWidth: true, disabled: !hasWinners, "aria-label": winnersButtonLabel, onClick: this.onViewWinnersClicked, className: 'containedButton' }, { children: winnersButtonLabel }))) : ((0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ size: "large", variant: "contained", color: config_2.config.internalConfig.BUTTON_BACKGROUND, fullWidth: true, "aria-label": 'Enter Drawing', onClick: this.props.onRedeem, className: 'containedButton' }, { children: "Enter" }))), !!rewardCost && ((0, jsx_runtime_1.jsxs)(core_1.Grid, Object.assign({ container: true, alignItems: 'center', justifyContent: 'flex-start', style: { marginTop: this.props.theme.spacing(2), alignItems: 'center' } }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.default, { iconName: config_2.config.internalConfig.REWARDS_ICON, iconType: 'custom' }), (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: 'subtitle1' }, { children: rewardCost }))] })))] })), (0, jsx_runtime_1.jsx)(core_1.Hidden, Object.assign({ mdDown: true }, { children: (0, jsx_runtime_1.jsx)(core_1.Grid, { item: true, lg: 5 }) }))] }));
        this.renderRulesLink = (drawRulesDocument) => {
            const { classes, t } = this.props;
            return ((0, jsx_runtime_1.jsxs)("a", Object.assign({ className: classes.rulesLink, href: drawRulesDocument, target: "external" }, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "subtitle1", color: config_2.config.internalConfig.BUTTON_BACKGROUND }, { children: t('drawDetails.drawRuleFileName') })), this.props.rulesIcon ? (0, jsx_runtime_1.jsx)(Icon_1.default, { color: "primary", iconType: 'material', iconName: this.props.rulesIcon }) : null] })));
        };
        this.renderTabs = (draw, tabs, drawPrizes, additionalInformation, rulesDocument) => {
            const { classes } = this.props;
            const { selectedTab } = this.state;
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(core_1.Grid, Object.assign({ item: true, xs: 12 }, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "body1", color: "textPrimary", style: { paddingBottom: this.props.theme.spacing(2) } }, { children: !!draw.description && (0, jsx_runtime_1.jsx)(ReadMore_1.default, { context: draw.description, isHtml: true, maxLines: 12 }) })), rulesDocument ? this.renderRulesLink(rulesDocument) : null] })), !config_2.config.internalConfig.HIDE_REWARDS_INFO && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12, style: { paddingTop: this.props.theme.spacing(2) } }, { children: (0, jsx_runtime_1.jsx)(ChipTabs_1.default, { tabs: tabs, selectedTab: this.state.selectedTab, selectTab: this.onTabSelected }) })), selectedTab === 'prizes' ? ((0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ className: classes.prizes, item: true, xs: 12 }, { children: drawPrizes.map((prize, index) => {
                                    var _a;
                                    return ((0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ className: classes.prizeSummary, variant: "body1", color: "textPrimary" }, { children: prize.summary }), (_a = prize.id) !== null && _a !== void 0 ? _a : index));
                                }) }))) : ((0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ className: classes.additionalInfo, item: true, xs: 12 }, { children: !!additionalInformation && (0, jsx_runtime_1.jsx)(ReadMore_1.default, { context: additionalInformation, isHtml: true, maxLines: 12 }) })))] }))] }));
        };
        this.renderPrizesLink = () => {
            const { classes } = this.props;
            return ((0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)("a", Object.assign({ className: classes.prizeDescriptionLink, href: "#", onClick: this.onViewCompletePrizeDescriptionClicked }, { children: (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "subtitle1", color: "primary" }, { children: "View Complete Prize Description" })) })) })));
        };
        this.renderWinnersDialog = (title, open, drawStartDate, drawEndDate, drawDate, drawPrizesWithWinners, isSweepStake) => ((0, jsx_runtime_1.jsx)(WinnersDialog_1.default, { title: title, open: open, drawEndDate: drawEndDate, drawDate: drawDate, drawPrizesWithWinners: drawPrizesWithWinners, onClose: this.hideWinnersDialog, drawStartDate: drawStartDate, isSweepStake: isSweepStake, onViewPrizeDetailsClicked: this.onViewPrizeDetailsAndImagesClicked }));
        this.renderPrizesDialog = (title, open, draw, drawPrizes, prizes, drawPrizeContentRetrieved) => ((0, jsx_runtime_1.jsx)(PrizesDialog_1.default, { title: title, open: open, onClose: this.hidePrizesDialog, drawPrizeContentRetrieved: drawPrizeContentRetrieved, drawPrizes: drawPrizes, prizes: prizes, draw: draw }));
        this.onTabSelected = (tab) => {
            this.setState({ selectedTab: tab });
        };
        this.onViewCompletePrizeDescriptionClicked = () => {
            this.showPrizesDialog();
        };
        this.onViewWinnersClicked = () => {
            this.showWinnersDialog();
        };
        this.onViewPrizeDetailsAndImagesClicked = () => {
            this.hideWinnersDialog();
            this.showPrizesDialog();
        };
        this.showWinnersDialog = () => {
            const { drawDetail: { drawPrizeWinnersRetrieved } } = this.props;
            if (!drawPrizeWinnersRetrieved) {
                this.retrieveWinnersForDrawPrizes();
            }
            this.setState({ showPastWinners: true });
        };
        this.hideWinnersDialog = () => {
            this.setState({ showPastWinners: false });
        };
        this.showPrizesDialog = () => {
            const { drawDetail: { drawPrizeContentRetrieved } } = this.props;
            if (!drawPrizeContentRetrieved) {
                this.retrieveContentForDrawPrizes();
            }
            this.setState({ showCompletePrizeDescription: true });
        };
        this.hidePrizesDialog = () => {
            this.setState({ showCompletePrizeDescription: false });
        };
        this.retrieveWinnersForDrawPrizes = async () => {
            const { drawDetail: { draw } } = this.props;
            if (draw) {
                await this.props.fetchDrawPrizesWithWinners(draw);
            }
        };
        this.retrieveContentForDrawPrizes = async () => {
            const { drawDetail: { draw } } = this.props;
            if (draw) {
                await this.props.fetchDrawPrizesWithContent(draw);
            }
        };
        this.state = {
            selectedTab: 'prizes',
            showPastWinners: false,
            showCompletePrizeDescription: false,
            launchVideo: false
        };
    }
    render() {
        const { drawDetail: { draw, latestDrawHistory, drawPrizes, prizes, drawPrizeContentRetrieved, drawPrizesWithWinners }, showPrizesLink, isLoggedIn, selectedReward } = this.props;
        const { showPastWinners, showCompletePrizeDescription } = this.state;
        if (!draw) {
            return null;
        }
        const image = !!draw.drawFullImage
            ? (0, mediaUtil_1.createMediaURL)(config_2.config.internalConfig.BASE_URL, config_2.config.internalConfig.MEDIA_API, draw.drawFullImage)
            : assets_1.assets.internalAssets.noImage;
        const { drawStartDate, drawEndDate, drawDate } = getDrawDates(draw);
        const hasWinners = !!latestDrawHistory && latestDrawHistory.winnersPublished;
        const winnersButtonLabel = hasWinners ? 'Winners' : 'No Winners Yet!';
        const title = draw.name;
        const completePrizeDescriptionDialogTitle = `Prize Details - ${title}`;
        const tabs = ['prizes', 'information'];
        const winnersDialogTitle = `${title} - Winners`;
        const isSweepStake = draw.drawClassification === 'SWEEPSTAKES';
        const drawEnded = draw.end && (0, TimeUtil_1.zonedDateTimeFor)(draw.end).isBefore((0, TimeUtil_1.now)());
        const rewardCost = this.getRewardCost(draw, selectedReward);
        const pointsBalance = !!this.props.userPoints && !!this.props.userPoints.redeemablePoints
            ? numeral(this.props.userPoints.redeemablePoints).format('0,0[.]0')
            : '0';
        return ((0, jsx_runtime_1.jsxs)(core_1.Grid, Object.assign({ container: true, style: { marginLeft: this.props.theme.spacing(2) } }, { children: [this.props.renderTitle ? this.props.renderTitle() : null, this.renderImage(title, image), (0, jsx_runtime_1.jsxs)(core_1.Grid, Object.assign({ item: true, xs: 12, md: 5, lg: 6, xl: 6 }, { children: [this.renderStats(drawStartDate, drawEndDate, drawDate, pointsBalance, isLoggedIn), this.getTotalEntries(), this.renderButtons(hasWinners, winnersButtonLabel, drawEnded, rewardCost)] })), this.renderTabs(draw, tabs, drawPrizes, draw.additionalInformation, draw.rulesDocument), !config_2.config.internalConfig.HIDE_REWARDS_INFO && showPrizesLink && this.state.selectedTab === 'prizes' ? this.renderPrizesLink() : null, this.renderWinnersDialog(winnersDialogTitle, showPastWinners, drawStartDate, drawEndDate, drawDate, drawPrizesWithWinners, isSweepStake), this.renderPrizesDialog(completePrizeDescriptionDialogTitle, showCompletePrizeDescription, draw, drawPrizes, prizes, drawPrizeContentRetrieved)] })));
    }
    getRewardCost(draw, selectedReward) {
        try {
            const rewardId = draw.externalId;
            if (!!rewardId) {
                const rewardObj = selectedReward;
                const cost = !!rewardObj ? numeral(rewardObj.num_points).format('0,0[.]0') : '0';
                const points = !!rewardObj ? rewardObj.num_points.getPointsUnit() : 'Points';
                return !!cost ? `${this.props.t('rewards.redeemFor')}: ${cost} ${points}` : '';
            }
            return '';
        }
        catch (e) {
            return '';
        }
    }
}
exports.default = (0, withTheme_1.default)((0, withStyles_1.default)(DrawDetailStyle_1.default)((0, react_i18next_1.withTranslation)()(PastDrawDetail)));
//# sourceMappingURL=PastDrawDetail.js.map